import moment from "moment";
const duration = 5 * 60;

const isInFiveTime = (curTime, baseTime) => curTime - baseTime <= duration;

export const addTimeDivider = (messageList, baseTime = 0) => {
  return messageList.reduce((acc, cur) => {
    const curTime = cur.message_client_time;
    if (isInFiveTime(curTime, baseTime)) {
      return [...acc, cur];
    } else {
      baseTime = curTime;
      return [...acc, { isTimeDivider: true, time: curTime }, cur];
    }
  }, []);
};

// 获取文件消息日期列表
export const getFileDateList = (messageList) => {
  let fileDateList = [];
  messageList.forEach((cur) => {
    if (
      cur?.message_elem_array?.length &&
      cur.message_elem_array[0].elem_type === 4
    ) {
      let send_at = cur?.send_at || cur.message_client_time;
      let date = moment(send_at * 1000).format("YYYY-MM");
      if (!fileDateList.includes(date)) {
        fileDateList.push(date);
      }
    }
  });
  return fileDateList;
};
